import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '@mdi/react';
import { mdiDotsHorizontal } from '@mdi/js';
import { IconButton, Menu, MenuItem } from '@mui/material';
import PopupTitle from '../common/popup_title';
import AddToPlannerModal from '../meal/add_to_planner_modal';
import DeleteCardConfirmPopover from '../common/delete_card_confirm_popover';

const ProgrammePlanDayActionsPopupMenu = ({
  programmeId,
  onCopyToProgramme,
  setGlobalSnackbar,
  onRemoveMealsAndGRCRecipes,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = !!anchorEl;

  const [copyToPlannerAnchorEl, setCopyToPlannerAnchorEl] = useState(null);

  const [deletePopupAnchorEl, setDeletePopupAnchorEl] = useState(null);

  const handleClick = (event) => {
    setCopyToPlannerAnchorEl(null);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setCopyToPlannerAnchorEl(null);
    setAnchorEl(null);
  };
  const handleCopyToAnotherPlan = (event) => {
    // setAnchorEl(null);
    setCopyToPlannerAnchorEl(event.currentTarget);
  };
  const handleRemoveMealsAndGRCRecipes = () => {
    // setAnchorEl(null);
    setDeletePopupAnchorEl(null);
    setCopyToPlannerAnchorEl(null);
    handleClose();
    onRemoveMealsAndGRCRecipes();
  };

  return (
    <>
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}>
        <PopupTitle
          titleText="Menu actions"
          closeButtonEnabled
          onClickClose={handleClose}
        />
        <MenuItem onClick={handleCopyToAnotherPlan}>
          Copy to another plan
        </MenuItem>
        <MenuItem
          onClick={(ev) => {
            setDeletePopupAnchorEl(ev.target);
          }}>
          Remove meals
        </MenuItem>
      </Menu>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls="long-menu"
        aria-expanded={open && 'true'}
        aria-haspopup="true"
        size="small"
        onClick={handleClick}>
        <Icon
          path={mdiDotsHorizontal}
          style={{ width: '24px', height: '24px' }}
        />
      </IconButton>
      {copyToPlannerAnchorEl && (
        <AddToPlannerModal
          anchorEl={copyToPlannerAnchorEl}
          copyToProgrammesEnabled
          destinationProgrammeIDs={[programmeId]}
          onCopyToProgramme={(toProgrammeId, toPlanId, dayIndexes) => {
            onCopyToProgramme(toProgrammeId, toPlanId, dayIndexes);
            setCopyToPlannerAnchorEl(null);
            setGlobalSnackbar({
              notificationText: 'Your meals have been copied to your program',
              linkText: 'View program',
              linkTarget: `/programmes/${toProgrammeId}/plans/${toPlanId}`,
            });
          }}
          onDismiss={() => setCopyToPlannerAnchorEl(null)}
        />
      )}
      <DeleteCardConfirmPopover
        anchorEl={deletePopupAnchorEl}
        visible={!!deletePopupAnchorEl}
        onDismiss={() => setDeletePopupAnchorEl(null)}
        message="All the meals in this day will be removed. Are you sure?"
        onConfirmDelete={handleRemoveMealsAndGRCRecipes}
        height={160}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        title="Remove meals"
      />
    </>
  );
};

ProgrammePlanDayActionsPopupMenu.propTypes = {
  programmeId: PropTypes.string.isRequired,
  onCopyToProgramme: PropTypes.func.isRequired,
  setGlobalSnackbar: PropTypes.func.isRequired,
  onRemoveMealsAndGRCRecipes: PropTypes.func.isRequired,
};

export default ProgrammePlanDayActionsPopupMenu;
